module.exports = __webpack_public_path__ + "static/media/snippet_alive_m.b6c58e22.png";